import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getSurveyData, postSurveyData } from './services/api';
import SurveyTitle from './surveyTitle';
import SurveyContent from './surveyContent';

class Survey extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
    };

    state = {
        data: {},
        status: 0,
        selectValue: {},
        valueCheck: [],
        resultShow: false,
        tipShow: false,
        isSubmit: false,
    };

    async componentDidMount() {
        try {
            const { surveyId } = this.props;

            const data = await getSurveyData(surveyId);

            if (data.ifsuccess) {
                this.setState({
                    data: data.data,
                    status: data.ifsuccess,
                    resultShow: data.data.surveyinfo.expire === '0',
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    handleShow = () => {
        this.setState({
            tipShow: true,
            resultShow: true,
        });

        this.timer = setTimeout(() => {
            this.setState({ tipShow: false });
        }, 1000);
    };

    handleSelect = e => {
        const selectValue = { ...this.state.selectValue };
        const type = e.currentTarget.type;
        const value = e.currentTarget.value;
        const qid = e.currentTarget.attributes.qid.value;

        if (type === 'radio') {
            selectValue[qid] = value;
        } else if (type === 'checkbox') {
            if (selectValue[qid]) {
                if (selectValue[qid].includes(value)) {
                    selectValue[qid].splice(selectValue[qid].indexOf(value), 1);
                } else {
                    selectValue[qid].push(value);
                }
            } else {
                selectValue[qid] = [];
                selectValue[qid].push(value);
            }
            selectValue[qid] = [...new Set(selectValue[qid])];
        }

        this.setState({ selectValue });
    };

    handleSubmit = async () => {
        try {
            const { values, entries } = Object;
            const { data, selectValue } = this.state;
            const valueCheck = [];
            const result = data.result;

            result.forEach((item, index) => {
                // 1 必答 0 选答
                const ismust = item.resultArray.ismust;

                if (ismust) {
                    if (values(selectValue).length === 0) {
                        valueCheck.push(index);
                    }
                    for (const v of values(selectValue)) {
                        if (v === '' || v.length === 0) {
                            valueCheck.push(index);
                        }
                    }
                }
            });

            this.setState({ valueCheck });

            if (valueCheck.length === 0) {
                const { surveyId } = this.props;
                const value = [];

                for (const [k, v] of entries(selectValue)) {
                    if (k && v) {
                        if (typeof v === 'string') {
                            value.push(`sur[${k}][]=${v}`);
                        } else {
                            v.forEach(item => {
                                value.push(`sur[${k}][]=${item}`);
                            });
                        }
                    }
                }

                const survey = await postSurveyData(value.join('&'), surveyId);

                this.setState({
                    resultShow: true,
                });

                if (survey.ifsuccess) {
                    this.setState({
                        isSubmit: true,
                    });
                }

                window.alert(survey.msg);
            }
        } catch (e) {
            console.error(e);
        }
    };

    render() {
        const { data, status, valueCheck, selectValue, resultShow, tipShow, isSubmit } = this.state;
        let props = {};

        if (isSubmit) {
            props = { disabled: 'disabled' };
        }

        return (
            <div className={styles.survey} onKeyDown={this.handleKeyDown}>
                {status === 1 ? (
                    <div className={styles.survey_box}>
                        <SurveyTitle
                            expire={data.surveyinfo.expire}
                            pnum={data.surveyinfo.pnum}
                            channelurl={data.surveyinfo.channelurl}
                            id={data.surveyinfo.id}
                            title={data.surveyinfo.title}
                        />
                        <div className={styles.survey_content}>
                            <SurveyContent
                                data={data}
                                valueCheck={valueCheck}
                                selectValue={selectValue}
                                resultShow={resultShow}
                                handleSelect={this.handleSelect}
                            />
                            {data.surveyinfo.expire === '0' ? (
                                <div className={styles.survey_end}>
                                    <span>抱歉，本调查已经结束。</span> 截止时间：<span>
                                        {data.surveyinfo.endtime.split(':')[0]}:00
                                    </span>
                                </div>
                            ) : (
                                <div>
                                    {tipShow ? <div className={styles.tip}>请选择您的观点，然后提交</div> : ''}
                                    <div className={styles.submit}>
                                        <div className={styles.all}>
                                            <span onClick={this.handleShow}>{'点击查看结果>>'}</span>
                                        </div>
                                        <button
                                            type="button"
                                            className={isSubmit ? styles.submited_btn : styles.submit_btn}
                                            {...props}
                                            onClick={this.handleSubmit}>
                                            {isSubmit ? '已提交' : '提交'}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default Survey;
